import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import DailyActivity from "../components/dailyActivityReport/DailyActivity";

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer
    };
}

export default connect(mapStateToProps, null)(DailyActivity);



// WEBPACK FOOTER //
// ./src/containers/DailyActivityContainer.js